// src/contexts/citationTooltipGroup.ts

/**
 * Shared shape for a citation tooltip that pages through a merged chip's
 * citations (see citationGroups.ts). Used by the document, playbook and
 * Catylex tooltip contexts; a single citation leaves `group` null.
 */
export interface CitationTooltipGroup<T> {
  /** Tooltip data for each citation in the chip, in chip order. */
  items: T[];
  /** The citation currently shown. */
  index: number;
  /** The merged chip the tooltip belongs to, so only that chip pages or toggles it. */
  anchorEl: HTMLElement;
}

/** Step `index` by `delta`, wrapping around both ends. */
export const wrapIndex = (index: number, total: number): number =>
  ((index % total) + total) % total;
